import { Link } from "react-router-dom";
import { Instagram, MapPin } from "lucide-react";
import { site } from "../data/siteConfig";
import { Reveal } from "../components/Reveal";
import { useTitle } from "../hooks/useTitle";

export default function AboutPage() {
  useTitle("About Yaya | HairByYaya");

  return (
    <div className="px-5 pb-24 pt-28 md:pt-36" data-testid="about-page">
      <div className="mx-auto grid max-w-6xl items-center gap-12 lg:grid-cols-2">
        <Reveal className="relative">
          <div
            className="absolute -inset-3 rounded-[2rem] border border-hotpink/40"
            aria-hidden="true"
          />
          <img
            src="/assets/gallery/about.jpg"
            alt="Portrait of a woman with soft braided hair representing Yaya"
            className="relative aspect-[4/5] w-full rounded-[2rem] object-cover"
          />
          <img
            src={site.assets.logoScript}
            alt="Yaya Just Did That logo badge"
            className="absolute -bottom-8 -right-4 h-28 w-28 rounded-full shadow-[0_10px_40px_-10px_rgba(255,20,147,0.7)] ring-2 ring-hotpink/60 md:h-36 md:w-36"
          />
        </Reveal>

        <Reveal delay={0.15}>
          <p className="font-script text-4xl text-hotpink">meet</p>
          <h1 className="mt-1 font-serif text-6xl md:text-7xl">Yaya</h1>
          <p className="mt-6 leading-relaxed text-white/65">
            Yaya specializes in beautiful protective styles designed to make
            every client leave feeling polished, confident, and seen. From clean
            feed-in braids to detailed protective styles, every appointment is
            approached with care, creativity, and attention to detail.
          </p>
          <p className="mt-4 leading-relaxed text-white/65">
            Based in Hampton, Virginia, Yaya built her name one clean part at a
            time — and now every look leaves the chair ready for its close-up.
          </p>

          <div className="mt-7 flex flex-wrap gap-2 text-xs">
            <span className="flex items-center gap-1.5 rounded-full border border-white/15 px-4 py-2 text-white/75">
              <MapPin className="h-3.5 w-3.5 text-hotpink" /> Hampton, Virginia
            </span>
            <a
              href={site.instagram.url}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1.5 rounded-full border border-white/15 px-4 py-2 text-white/75 transition-colors duration-300 hover:border-hotpink hover:text-hotpink"
              data-testid="about-instagram-link"
            >
              <Instagram className="h-3.5 w-3.5 text-hotpink" />
              {site.instagram.handle}
            </a>
          </div>

          <Link
            to="/book"
            data-testid="about-book-now"
            className="mt-9 inline-block rounded-full bg-hotpink px-9 py-4 text-xs font-bold uppercase tracking-[0.25em] text-white transition-colors duration-300 hover:bg-magenta"
          >
            Book Now
          </Link>
          <p className="mt-6 text-[11px] text-white/30">
            Placeholder biography — Yaya's final bio and portrait will replace
            this content.
          </p>
        </Reveal>
      </div>
    </div>
  );
}

